declare const jQuery: any;
const $ = jQuery;

export function initInputs(): void
{
    const $wraps = $(`[data-input]`);
    if ($wraps.length === 0)
    {
        return;
    }
    $wraps.each(function () {
        const $wrap = $(this);
        const $input = $wrap.find(`input[type="text"],select`);
        if ($input.length === 0)
        {
            console.error(`hs-input has no input el`, $wrap[0]);
            return;
        }
        if ($input.length > 1)
        {
            console.error(`hs-input has ${$input.length} input els, should have 1`, $wrap[0]);
            return;
        }
        $input.on("change", (event) => {
            event.stopPropagation();
            $wrap.trigger("change", $input.val());
        });
        $wrap.on("update", (event, value: string) => {
            if (value !== $input.val())
            {
                $input.val(value).trigger("changed");
            }
        });
    });
}

export function getReCaptchaWidgetId($captchaWrap) {
    const captcha = $captchaWrap.find(`.g-recaptcha`)[0];
    if (!captcha) {
        console.error(`captcha div not found in wrap`);
        return undefined;
    }
    let id: any = undefined;
    $(".g-recaptcha").each(function (index: number) {
        if (this === captcha) {
            id = index;
            return false;
        }
    });
    return id;
}
